export const isEnterprisePlan = (planName = '') => {
  return planName.toLowerCase() === 'enterprise';
};
